import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, useFormik, FormikProvider } from 'formik';
import { Typography } from '@material-ui/core';

// Components
import { FileUploader } from 'components/global/fileUploader';

// Store + Core
import { LEARNER_VALIDATION_TOOL_UPLOAD_FILE_TYPES } from 'core/constants';
import { batchLearnerValidation, batchLearnerValidationClearAction } from 'store/learner/actions';
import { learnerValidationFileSelector, uploadLearnerValidationPercentageSelector } from 'store/learner/selectors';

// Types
export interface IBatchLearnerValidationFormValues {
  file: File;
}

export const LearnerValidationToolBatchForm = (): ReactElement => {
  const dispatch = useDispatch();

  // Redux State.
  const uploadPercentage: number = useSelector(uploadLearnerValidationPercentageSelector);
  const uploadedFile = useSelector(learnerValidationFileSelector);

  const onClearFile = (): void => {
    dispatch(batchLearnerValidationClearAction());
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async (values): Promise<void> => {
      // API call - upload file.
      await dispatch(batchLearnerValidation({ file: values as { file: File } }));
    },
  });
  const { handleSubmit } = formik;

  return (
    <FormikProvider value={formik}>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <Field
          component={FileUploader}
          fileTypes={LEARNER_VALIDATION_TOOL_UPLOAD_FILE_TYPES}
          id="batchLearnerValidationFile"
          name="file"
          showDropZoneSubTitle={false}
          onClearFile={onClearFile}
          uploadedFile={uploadedFile}
          uploadPercentage={uploadPercentage}
        />
        <Typography variant="srOnly">
          <button tabIndex={-1}>Submit</button>
        </Typography>
      </form>
    </FormikProvider>
  );
};
